<div class="archive-item  d-flex" style=" width:100%; flex-direction: column; ">


    <div class="item-inf row" >
        <h1 class="info-header col-md-9">{{newsData?.flatData?.newsTitle}}</h1>
        <h3  class="col-lg-3 text-gray" style="text-align: end;"><strong class="custom-color">{{ ' تاريخ النشر : ' }}</strong> <span >{{newsData?.flatData?.publishDate|date}}</span></h3>
</div>
<div style="max-height: 3em; overflow: hidden;">
    <p style="white-space: pre-line;" [innerHTML]="newsData?.flatData?.newsSummary">
    </p>
</div>


</div>
